import React from 'react';
import cx from 'classnames';
import styles from './profileIcon.module.scss';
import Icon from '../Icon/Icon';

const ProfileIcon: React.FC<any> = ({ className }): JSX.Element | null => {
  const commonProps = {
    className: cx(styles.profileIcon, className),
  };

  return <Icon {...commonProps} iconName="user" />;
};

export default ProfileIcon;
